module.exports = __webpack_public_path__ + "static/media/invisible-button.d0b4a4b6.png";